import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import coal from 'sushiweb/tokens/color/black';
import white from 'sushiweb/tokens/color/white';
import Input from 'sushiweb/InputTypes/Input';

export const ModalTitle = styled.h2`
  font-family: Lexend-600;
  font-size: 2rem;
  color: ${coal};
  margin: 0;
`;

export const FormWrapper = styled.div`
  padding: 2.4rem 2.4rem 2.4rem 2.4rem;
`;

export const InputWrapper = styled.div`
  margin-bottom: 2rem;
  position: relative;
`;

export const RupeePrefix = styled.span`
  position: absolute;
  left: 1.4rem;
  top: 1.8rem;
  font-size: 1.6rem;
  color: ${coal};
  pointer-events: none;
  z-index: 1;
  line-height: 1;
`;

export const AmountInput = styled(Input)`
  width: 100%;
  input {
    font-size: 1.6rem !important;
  }
`;

export const QuickAmountRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const QuickAmountButton = styled.button`
  flex: 1;
  margin-top: -1.8rem;
  margin-bottom: 1rem;
  padding: 1.2rem 1rem;
  border-radius: 10px;
  border: 0.1rem solid ${grey.z200};
  background: ${({ selected }) => (selected ? coal : white)};
  color: ${({ selected }) => (selected ? white : coal)};
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
`;

export const SummaryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 0.1rem solid ${grey.z200};
  margin-bottom: 2.4rem;
  p {
    font-size: 1.5rem;
    color: ${grey.z700};
  }
`;

export const UpdatedLimitAmount = styled.span`
  font-size: 1.8rem;
  font-weight: 600;
  color: ${coal};
`;

export const PayButtonWrapper = styled.div`
  button {
    width: 100%;
  }
`;
